import styled from "styled-components";

const DivFlexMarginCenter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
`;

export default DivFlexMarginCenter;
